import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=7c560ac4&scoped=true"
import script from "./AllCompanies.vue?vue&type=script&lang=js"
export * from "./AllCompanies.vue?vue&type=script&lang=js"
import style0 from "./AllCompanies.vue?vue&type=style&index=0&id=7c560ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c560ac4",
  null
  
)

export default component.exports